import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, CheckCircle, Star, Users, Clock } from 'lucide-react';

export const TrustBadges = () => {
  const badges = [
    { icon: Shield, text: 'Unabhängig & Neutral', highlight: true },
    { icon: Users, text: 'Erfahrene Gutachter', highlight: false },
    { icon: Star, text: 'Top bewertet', highlight: false },
    { icon: Clock, text: '30 Min vor Ort', highlight: true },
  ];

  return (
    <section className="py-8 bg-gradient-to-r from-slate-50 via-white to-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {badges.map((badge, idx) => (
            <motion.div 
              key={idx}
              className={`flex items-center gap-3 px-5 py-3 rounded-full transition-all duration-300 cursor-default
                ${badge.highlight 
                  ? 'bg-[#22c55e]/10 border border-[#22c55e]/30 hover:bg-[#22c55e]/20' 
                  : 'bg-white border border-slate-200 hover:border-slate-300 hover:shadow-md'
                }`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1, duration: 0.4 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, y: -2 }}
            >
              <badge.icon className={`w-5 h-5 ${badge.highlight ? 'text-[#22c55e]' : 'text-slate-600'}`} />
              <span className={`text-sm font-semibold ${badge.highlight ? 'text-[#22c55e]' : 'text-slate-700'}`}>
                {badge.text}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
